<template>
  <div class="files-upload-multiple">
    <div class="files-upload-multiple__list">
      <div v-for="(item, index) in value"
           :key="item.id"
           class="files-upload-multiple__item">
        <div class="files-upload-multiple__item-inner">
          <button type="button"
                  @click="onDelete(index)"
                  class="files-upload-multiple__btn-delete">
            <BaseSvg name="ico-trash"/>
          </button>
          <FileShow :value="item"
                    class="files-upload-multiple__item-file  _cover  handle"/>
          <BasePreloader v-if="pendingFile"/>
        </div>
      </div>

      <div v-if="value.length < max"
           class="files-upload-multiple__item _add">
        <div class="files-upload-multiple__item-inner  files-upload-multiple__add"
             :class="{'_drag-over': dragoverMixin}"
             @drop.prevent="onDropMixin"
             @dragover.prevent="onDragenterMixin"
             @dragleave.prevent="onDragleaveMixin">
          <input ref="fileInput"
                 class="d-none"
                 type="file"
                 :multiple="max > 1"
                 :accept="filesTypes"
                 @change="onFilesInputMixin">
          <button class="files-upload-multiple__add-btn  base-btn base-btn--blue"
                  @click="$refs.fileInput.click()">
            <BasePreloader v-if="pending"/>
            <BaseSvg name="ico-plus"/>
          </button>
        </div>
      </div>
    </div>

    <BaseAlertInline :value="error || errorMixin"
                     class="files-upload-multiple__errors  _error"/>
  </div>
</template>

<script>
  import FileShow from '@/components/FileShow'
  import BaseAlertInline from '@/components/BaseAlertInline'
  import fileUploadMixin from '@/mixins/fileUploadMixin'
  import {
    VIDEOS_MIME_TYPES,
    IMAGES_MIME_TYPES,
    OTHER_MIME_TYPES,
    ALLOWED_IMAGES_EXTS,
    ALLOWED_VIDEOS_EXTS,
    ALLOWED_OTHER_EXTS
  } from '@/constants/files'

  export default {
    name: 'FilesUpload',
    mixins: [fileUploadMixin],
    components: {
      FileShow,
      BaseAlertInline
    },
    props: {
      value: Array,
      error: [String, Array],
      pending: Boolean,
      pendingFile: Boolean,
      outsideDelete: Boolean,
      max: {
        type: Number,
        default: 10
      },
      filesExtsMixin: {
        type: Array,
        default: () => ([...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS, ...ALLOWED_OTHER_EXTS])
      },
      filesMimeTypes: {
        type: Array,
        default: () => ([...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES, ...OTHER_MIME_TYPES])
      }
    },
    data(vm) {
      return {
        uploadFileMethodNameMixin: ['upload'],
        allowedFilesExtsMixin: vm.filesExtsMixin,
        allowedFilesMimeTypes: vm.filesMimeTypes
      }
    },
    computed: {
      filesTypes() {
        return this.allowedFilesMimeTypes.join(', ')
      },
    },
    methods: {
      upload(files) {
        files = Array.from(files).map(file => {
          return {
            file: file,
            path: URL.createObjectURL(file),
            type: file.type,
            size: file.size,
            name: file.name,
          }
        })
        const value = this.value || []
        this.$emit('input', [...value, ...files])
      },
      onDelete(index) {
        if (this.outsideDelete) { //outside delete
          return this.$emit('delete', index)
        } else {//inside delete
          let value = this.value || []
          value = [...value]
          this.$delete(value, index)

          this.$emit('input', value)
          this.$emit('delete', index)
        }
      },
    }
  }
</script>

<style lang="less">

</style>
